import {useEffect, useState} from "react";
import { Transition } from '@headlessui/react'

const ImagePreloader = props => {
    const { src, delay } = props

    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        const image = new Image()
        image.src = src
        image.onload = () => {
            setTimeout(() => {
                setLoaded(true)
            }, delay ?? 300)
        }
    }, [])

    return (
        <Transition
            show={loaded}
            enter="transition-opacity duration-1000"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-1000"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className={'w-full h-full'}
        >
            <img src={src} {...props}/>
        </Transition>
    )
}

export default ImagePreloader